/**
 * Způsob přiblížení na načtené features.
 */
enum FeatureZoom {
    /**
     * Vycentruje pohled na features bez změny zoomu.
     */
    CENTER = 'CENTER',

    /**
     * Vycentruje pohled na features a provede zoom.
     */
    CENTER_AND_ZOOM = 'CENTER_AND_ZOOM',
}

export default FeatureZoom;
